import React from 'react';

class Search extends React.PureComponent {
  render() {
    const { search, onSearchChange } = this.props;
    const style = {
      maxWidth: '500px',
      margin: '30px 0',
    };
    return (
      <form style={style} >
        <input
          placeholder="Search..."
          className="form-control"
          type="text"
          style={{ display: 'inline-block', width: '50%' }}
          onChange={e => onSearchChange(e.target.value)}
        />
        {
          search
            ? <span role="presentation" style={{ padding: '10px' }} onClick={() => onSearchChange('')}>
              X
            </span>
            : null
        }
      </form>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/ReadManyLib/Search.js